import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {jsLatestStories} from '../lib/const';
import styles from './root.module.css';

type Props = PropsWithChildren;

export function LatestStoriesRoot({children}: Props) {
  return (
    <div
      className={clsx(
        styles.root,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      id={jsLatestStories}
    >
      {children}
    </div>
  );
}
